module.exports = __webpack_public_path__ + "img/people.f74b3772.svg";